import { Stat } from '@/components/Stat'
import { useSurveyStats } from '@/data-access/surveys/queries'

interface AdminStatsProps {
	className?: string
}

function OngoingPolls({ className }: AdminStatsProps) {
	const { data } = useSurveyStats()

	return (
		<Stat className={className} label="Ongoing Polls" value={data?.count.ongoing ?? 0}>
			<Stat.Label />
			<Stat.Number />
		</Stat>
	)
}

function UpcomingPolls({ className }: AdminStatsProps) {
	const { data } = useSurveyStats()

	return (
		<Stat className={className} label="Upcoming Polls" value={data?.count.upcoming ?? 0}>
			<Stat.Label />
			<Stat.Number />
		</Stat>
	)
}

function EndedPolls({ className }: AdminStatsProps) {
	const { data } = useSurveyStats()

	return (
		<Stat className={className} label="Ended Polls" value={data?.count.ended ?? 0}>
			<Stat.Label />
			<Stat.Number />
		</Stat>
	)
}

export { OngoingPolls, UpcomingPolls, EndedPolls }
